import * as React from 'react';
import { StepperProps, Stepper } from '@material-ui/core';

export type DSStepperProps = StepperProps;

export function DSStepper(props: DSStepperProps): JSX.Element {
    return <Stepper {...props}>{props.children}</Stepper>;
}
DSStepper.displayName = 'DSStepper';
